<template>
  <div class="location-row">
    <template v-if="showDistance">
      <aside class="distance">
        <img
          src="@/assets/images/map-pin-mini.svg"
          width="15"
          height="18"
          alt=""
        />
        <translate
          :tt="{ value: distance }"
          data-test="campsite-distance"
          data-nosnippet
        >
          {value, distance, short}
        </translate>
      </aside>
    </template>
    <span class="location" data-test="campsite-card-hierarchy">
      {{ hierarchyStringShort }}
    </span>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { PuCampsiteCardLocationSectionProps } from './PuCampsiteCardLocationSectionProps'

@Component
class PuCampsiteCardLocationSection
  extends Vue
  implements PuCampsiteCardLocationSectionProps
{
  @Prop({ required: true })
  hierarchyStringShort: string

  @Prop({ required: true })
  isPointSearch: boolean

  @Prop({ required: false })
  distance: { km: number; mi: number }

  get showDistance() {
    return this.isPointSearch && !!this.distance
  }
}

export default toNative(PuCampsiteCardLocationSection)
</script>

<style scoped>
.location-row {
  display: flex;
  justify-content: flex-start;
  align-items: baseline;
  gap: 0.35em;
}

.location,
.distance {
  font-size: var(--small);
  color: var(--colour-text-light);
}

.distance {
  color: var(--colour-text-default);
  margin-left: -0.1em;
  white-space: nowrap;
  flex-shrink: 0;
}

.distance img {
  width: 1em;
  height: 1.2em;
  margin: -0.25em -0.1em 0 0;
}
</style>
